import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { formatPlanDate, planNotice } from '../../../core/services/clinic-plan.rules';
import { ClinicPlanService } from '../../../core/services/clinic-plan.service';

/**
 * Strip above the app about the branch's clinic-app plan: see `planNotice` for
 * who hears what. Text only: the plan page is leaving clinic Settings, so there
 * is nowhere in this app to link to. Dismissal lasts the session.
 */
@Component({
  selector: 'app-plan-banner',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (notice(); as m) {
      <div
        class="flex items-center justify-center gap-3 px-10 py-2 text-sm font-semibold relative"
        [class]="m.severe ? 'bg-rose-50 text-rose-800' : 'bg-amber-50 text-amber-900'"
        role="status"
        aria-live="polite"
      >
        <span>{{ m.key | translate: { count: m.days, date: date(m.date) } }}</span>
        <button
          type="button"
          class="absolute right-2 top-1/2 -translate-y-1/2 rounded px-2 py-1 hover:bg-black/5 focus-visible:outline focus-visible:outline-2"
          [attr.aria-label]="'close' | translate"
          (click)="dismissed.set(true)"
        >
          ×
        </button>
      </div>
    }
  `,
})
export class PlanBanner {
  private readonly plans = inject(ClinicPlanService);

  protected readonly dismissed = signal(false);

  protected readonly notice = computed(() => (this.dismissed() ? null : planNotice(this.plans.plan())));

  protected readonly date = formatPlanDate;
}
